import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import store from './redux/store';
import Page from './containers/Page';
import { BrowserRouter } from 'react-router-dom';


ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <Page store={store} />
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root'),
);


// WEBPACK FOOTER //
// ./src/index.js